<template>
  <div
    class="card"
    @dragover.prevent="handleDragOver"
    @dragenter.prevent="handleDragEnter"
    @dragleave.prevent="handleDragLeave"
    @drop.prevent="handleDrop"
  >
    <div class="card-header">
      <ChatSelectGroup
        :show-model="false"
        :show-personality="false"
        :show-rag="true"
        v-model:model="selectedModel"
        v-model:model-label="selectedModelLabel"
        @open-modal="showModal = true"
      />
      <!-- モーダル -->
      <ModalSelectList
        v-if="showModal"
        :chatbots="chatbots"
        :initialSelectedBot="initialSelectedBot"
        @close="showModal = false"
        @bot-selected="$emit('bot-selected', $event)"
      />
    </div>
    <div class="card-body message-body-wrapper pb-0" ref="messageBody">
      <!-- 交互表示 -->
      <div v-for="(message, index) in messages" :key="index" class="mb-4">
        <!-- ユーザーのメッセージ（右）-->
        <div
          v-if="message.is_user"
          class="d-flex justify-content-end pe-3 mb-3"
        >
          <div class="message-wrapper">
            <div class="user-message-bubble">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <p
                class="mb-0 text-sm text-dark"
                v-html="parseMarkdown(message.text)"
              ></p>
            </div>
          </div>
        </div>

        <!-- AIのメッセージ（左）-->
        <div
          v-else
          class="d-flex justify-content-start mb-3"
          :class="{ 'message-preparing-answer': message.is_preparing }"
        >
          <div class="input-wrapper">
            <div class="bg-white border rounded p-3 shadow-sm">
              <div v-if="!message.text" class="d-flex align-items-center">
                <div class="spinner-grow text-dark me-2" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span v-if="this.$store.state.isMobileOpen">
                  ただいま回答準備中です。
                </span>
                <span v-else>
                  ただいま回答準備中です。少々お待ちください。
                </span>
              </div>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div
                class="mb-3 text-dark input-answer"
                v-html="parseMarkdown(message.text)"
              ></div>
              <div class="mb-3 d-flex justify-content-end gap-2">
                <!-- コピーするボタン -->
                <button
                  v-if="message.text"
                  class="btn btn-sm btn-outline-secondary px-2 mb-0"
                  type="button"
                  @click="copyToClipboard(message.text)"
                >
                  <i class="fas fa-copy" style="font-size: 0.75rem"></i>
                  コピーする
                </button>
              </div>
              <div
                v-if="message.text && message.vdb_results"
                :id="[`accordionRental-${index}`]"
                class="accordion"
              >
                <div class="mt-3 mb-2 text-danger text-xs text-bolder">
                  <template v-if="this.$store.state.isMobileOpen">
                    ※ 重要な決定を行う前に以下の資料をご確認ください。
                  </template>
                  <template v-else>
                    ※
                    この回答は参照元に基づいていますが、重要な決定を行う前に以下の資料をご確認ください。<br />
                    ※
                    提供された情報の正確性については、必ず事前確認をお願いいたします。
                  </template>
                </div>
                <div class="accordion-item">
                  <div :id="[`heading-${index}`]" class="accordion-header">
                    <button
                      class="accordion-button border-bottom font-weight-bold collapsed text-xs px-0"
                      type="button"
                      @click="toggleAccordion(index)"
                      data-bs-toggle="collapse"
                      :data-bs-target="[`#collapse-${index}`]"
                      :aria-expanded="isOpen[index] ? 'true' : 'false'"
                      :aria-controls="[`collapse-${index}`]"
                    >
                      <span class="text-xs"
                        ><span class="me-3">参照ファイルの詳細</span>
                        <span
                          v-for="bot in chatbots.filter((bot) =>
                            message.select_bot_id
                              ?.split(',')
                              .map((id) => id.trim())
                              .includes(String(bot.id)),
                          )"
                          :key="bot.id"
                          class="badge badge-secondary me-1"
                        >
                          {{ bot.name }}
                        </span>
                      </span>
                      <i
                        class="collapse-close fa fa-plus text-xs pt-1 position-absolute end-0 me-3"
                        aria-hidden="true"
                        ><span class="ms-1">開く</span></i
                      >
                      <i
                        class="collapse-open fa fa-minus text-xs pt-1 position-absolute end-0 me-3"
                        aria-hidden="true"
                        ><span class="ms-1">閉じる</span></i
                      >
                    </button>
                  </div>
                  <div
                    :id="[`collapse-${index}`]"
                    class="accordion-collapse collapse"
                    :class="{ show: isOpen[index] }"
                    :aria-labelledby="[`heading-${index}`]"
                    :data-bs-parent="[`#accordionRental-${index}`]"
                    style=""
                  >
                    <div class="accordion-body text-sm px-0">
                      <table class="align-items-center border mb-0">
                        <thead>
                          <tr class="bg-light">
                            <th
                              class="col-lg-2 py-2 text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >
                              資料名
                            </th>
                            <th
                              class="col-lg-8 py-2 text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              参照結果
                            </th>
                            <th
                              class="col-lg-1 py-2 text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              スコア
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(result, index) in message.vdb_results"
                            :key="index"
                            class="border-bottom"
                          >
                            <td>
                              <p
                                class="text-xs font-weight-bold py-3 px-2 mb-0"
                              >
                                {{ getSourceFilename(result.source) }}
                                <span>
                                  (<a
                                    class="text-info"
                                    href="#"
                                    @click.prevent="
                                      downloadFile(
                                        result.chatbot_id,
                                        getSourceFilename(result.source),
                                      )
                                    "
                                    ><span v-if="result.source.endsWith('pdf')"
                                      ><i
                                        class="fas fa-cloud-download-alt fa-lg mx-1"
                                        aria-hidden="true"
                                      ></i
                                      >ページ {{ +result.page + 1 }}</span
                                    ><span v-if="!result.source.endsWith('pdf')"
                                      ><i
                                        class="fas fa-cloud-download-alt fa-lg mx-1"
                                        aria-hidden="true"
                                      ></i></span></a
                                  >)
                                </span>
                              </p>
                            </td>
                            <td>
                              <p class="text-xs text-secondary py-3 px-2 mb-0">
                                {{ result.content }}
                              </p>
                            </td>
                            <td class="align-middle text-center">
                              <span
                                class="text-secondary text-xs font-weight-bold py-3 px-2 mb-0"
                                >{{ result.score.toFixed(2) }}</span
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 入力欄 -->
    <div
      class="position-sticky bottom-0 p-3 pt-2 mt-5 px-md-5 d-flex justify-content-center"
    >
      <div class="w-100 d-flex justify-content-center">
        <div
          class="input-group shadow-sm input-text-wrapper input-textarea input-wrapper-layout align-items-end"
          :class="{ dragging: isDragging }"
        >
          <div class="file-preview-area" v-if="attachedFiles.length > 0">
            <div class="file-list-wrap">
              <div
                class="file-item-wrap"
                v-for="(file, index) in attachedFiles"
                :key="index"
              >
                <div class="file-content">
                  <template v-if="isImageFile(file)">
                    <img
                      class="file-image-preview"
                      :src="getFilePreview(file)"
                      :alt="file.name"
                    />
                  </template>
                  <template v-else>
                    <i class="fas fa-paperclip me-2 text-secondary"></i>
                    <span class="file-name">{{ file.name }}</span>
                  </template>
                </div>
                <button
                  class="btn-remove"
                  @click="removeFile(index)"
                  title="削除"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- 選択モデル -->
          <div
            v-if="selectedModel"
            @click.stop="toggleToolMenu"
            class="selected-model-container"
          >
            <label class="selected-model-chip">
              言語モデル：{{ selectedModelLabel }}
            </label>
          </div>

          <!-- モデル選択メニュー -->
          <div v-if="showToolMenu" class="tool-menu">
            <div class="tool-menu-title">言語モデル</div>

            <div
              v-for="model in selectedModelOptions"
              :key="model.value"
              class="tool-menu-item"
              @click="selectModel(model)"
            >
              {{ model.label }}
            </div>
          </div>

          <div class="input-left-tools">
            <!-- +ボタン -->
            <label
              v-if="false"
              class="btn-plus mb-0"
              @click.stop="toggleToolMenu"
            >
              <i class="fas fa-plus" style="font-size: 18px; color: #555"></i>
            </label>
            <!-- ファイル添付ボタン -->
            <label
              class="mb-0"
              for="file-upload"
              style="cursor: pointer; margin-right: 8px"
            >
              <i
                class="fas fa-paperclip"
                style="font-size: 18px; color: #555"
              ></i>
            </label>
          </div>

          <input
            v-if="true"
            type="file"
            id="file-upload"
            ref="fileInput"
            multiple
            @change="handleInputFileChange"
            style="display: none"
            accept=".pdf,.csv,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
          />
          <textarea
            :class="[
              'form-control',
              { 'border-0': true, 'shadow-none': true, expanded: focused },
            ]"
            placeholder="気軽に質問してね！"
            @focus="focused = true"
            @blur="focused = false"
            v-model="userInput"
            @keydown.enter.exact.prevent="submitMessage"
            @keydown.enter.ctrl="insertNewLine"
            @paste="handlePaste"
            maxlength="7000"
          ></textarea>
          <!-- 送信ボタン/停止ボタン -->
          <div
            class="btn btn-icon-only btn-icon-send text-white rounded-circle"
            :class="isStreaming ? 'bg-secondary' : 'bg-dark'"
            @click="handleSubmitOrStop"
          >
            <i v-if="!isStreaming" class="far fa-comment-dots"></i>
            <i v-else class="fas fa-stop"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import ChatSelectGroup from '@/components/PageLayout/App/ChatSelectGroup.vue'
import ModalSelectList from '@/components/PageLayout/App/ModalSelectList.vue'

export default {
  name: 'ChatCard',
  components: {
    ModalSelectList,
    ChatSelectGroup,
  },
  props: {
    messages: {
      type: Array,
      required: true,
    },
    parseMarkdown: {
      type: Function,
      required: true,
    },
    attachedFiles: {
      type: Array,
      required: true,
    },
    downloadFile: {
      type: Function,
      required: true,
    },
    chatbots: {
      type: Array,
      required: false,
      default: () => [],
    },
    ragResult: {
      type: Array,
      required: false,
      default: () => [],
    },
    initialSelectedBot: {
      type: Object,
      default: null,
    },
    model: {
      type: String,
      default: '',
    },
    modelLabel: {
      type: String,
      default: '',
    },
    modelOptions: {
      type: Array,
      required: true,
    },
    isHistoryLoaded: {
      type: Boolean,
      default: false,
    },
    isStreaming: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'handle-dragover',
    'handle-drop',
    'handle-selected-model',
    'handle-selected-model-label',
    'send-message',
    'upload-files',
    'remove-file',
    'stop-stream',
  ],
  data() {
    return {
      focused: false,
      userInput: '',
      showModal: false,
      isDragging: false,
      dragCounter: 0,
      isOpen: {},
      selectedModel: this.model,
      selectedModelLabel: this.modelLabel,
      selectedModelOptions: this.modelOptions,
      showToolMenu: false,
    }
  },
  methods: {
    handleSubmitOrStop() {
      if (this.isStreaming) {
        this.$emit('stop-stream')
      } else {
        this.submitMessage()
      }
    },
    toggleToolMenu() {
      this.showToolMenu = !this.showToolMenu
    },
    selectModel(model) {
      this.showToolMenu = false
      this.selectedModel = model.value
      this.selectedModelLabel = model.label
      this.$emit('handle-selected-model', model.value)
      this.$emit('handle-selected-model-label', model.label)
    },
    handleDragEnter() {
      this.dragCounter++
      this.isDragging = true
    },
    handleDragLeave() {
      this.dragCounter--
      if (this.dragCounter === 0) {
        this.isDragging = false
      }
    },
    handleDrop(event) {
      this.dragCounter = 0
      this.isDragging = false
      this.$emit('handle-drop', event)
      this.$refs.fileInput.value = ''
    },
    handleDragOver(event) {
      this.$emit('handle-dragover', event)
      event.preventDefault()
    },
    handleInputFileChange(event) {
      this.$emit('upload-files', event)
      this.$refs.fileInput.value = ''
    },
    handlePaste(event) {
      const items = event.clipboardData?.items
      if (!items) return

      const files = []

      for (const item of items) {
        if (item.type.startsWith('image/')) {
          event.preventDefault()

          const file = item.getAsFile()
          if (!file) continue

          const ext = file.type.split('/')[1] || 'png'
          const fileName = `screenshot-${Date.now()}.${ext}`

          const newFile = new File([file], fileName, {
            type: file.type,
          })

          files.push(newFile)
        }
      }

      if (files.length === 0) return

      // ここがポイント：input[type=file]風のイベントを作る
      const pseudoEvent = {
        target: {
          files: files,
        },
      }

      // 既存ロジックに流す
      this.handleInputFileChange(pseudoEvent)
    },
    removeFile(index) {
      this.$emit('remove-file', index)
    },
    isImageFile(file) {
      return file.type.startsWith('image/')
    },
    getFilePreview(file) {
      return URL.createObjectURL(file)
    },
    getFileExtension(file) {
      return file.name.split('.').pop().toUpperCase()
    },
    toggleAccordion(index) {
      this.isOpen[index] = !this.isOpen[index]
    },
    sanitize(html) {
      return DOMPurify.sanitize(html)
    },
    submitMessage() {
      const trimmed = this.userInput.trim()
      if (trimmed) {
        this.$emit('send-message', trimmed)
        this.userInput = ''
      }
    },
    insertNewLine(event) {
      const textarea = event.target
      const start = textarea.selectionStart
      const end = textarea.selectionEnd
      this.userInput =
        this.userInput.substring(0, start) +
        '\n' +
        this.userInput.substring(end)
      this.$nextTick(() => {
        textarea.selectionStart = textarea.selectionEnd = start + 1
      })
    },
    copyToClipboard(text) {
      const processedText = text.replace(/\\n/g, '\n')
      navigator.clipboard.writeText(processedText)
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageBody
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    getSourceFilename(source) {
      const parts = source.split('/')
      //const filenameWithExtension = parts[parts.length - 1]
      return parts[parts.length - 1]
      /*
      if (!source.endsWith('pdf')) {
        return filenameWithExtension
      }
      const dotIndex = filenameWithExtension.lastIndexOf('.')
      const filename = filenameWithExtension.slice(0, dotIndex)
      return `${filename}_page_${+page + 1}.pdf`
      */
    },
    rateMessage(type, message) {
      console.log(`Rated ${type} for message:`, message)
      // サーバー送信など、必要に応じて処理を追加
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        document.body.classList.add('modal-open')
      } else {
        document.body.classList.remove('modal-open')
      }
    },
    selectedModel(newVal) {
      this.$emit('handle-selected-model', newVal)
    },
    selectedModelLabel(newVal) {
      this.$emit('handle-selected-model-label', newVal)
    },
    messages: {
      handler() {
        this.isOpen = {}
        if (this.isPreparingAnswer) {
          this.scrollToBottom()
        }
        if (this.isHistoryLoaded) {
          this.scrollToBottom()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    isPreparingAnswer() {
      return this.messages.some((m) => !m.is_user && !m.text)
    },
  },
  mounted() {
    this.scrollToBottom()
  },
}
</script>
